import BackendSettings from '../modules/siteSettings/components/backendSettings/components'
import ContactSetting from '../modules/siteSettings/components/contactSettings/ContactSetting'
import KeySettings from '../modules/siteSettings/components/keySetting/components'
import ModuleManager from '../modules/siteSettings/components/moduleManager/components/ModuleManager'
import Settings from '../modules/siteSettings/components/settings/components'
import SmtpSettings from '../modules/siteSettings/components/smtpSetting/components'
import Branches from '../modules/userMgmt/components/branch/components'
import Departments from '../modules/userMgmt/components/departments/components'
import RoleManagementIndex from '../modules/userMgmt/components/roles/components/RoleMgmt'
import UserRoleManagementIndex from '../modules/userMgmt/components/userRoles/UserRole'
import UserManagementIndex from '../modules/userMgmt/components/users/components/users'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'

import {RouteComponentProps} from 'react-router-dom'
import ContentManager from 'src/app/modules/cms/components/content/components/index'
import MenuManager from '../modules/cms/components/menu/components'

import Banner from '../modules/cms/components/banner/components'

import RoadBlockPopup from '../modules/cms/components/roadblockPopup/components'
import TextPopup from '../modules/cms/components/textPopup/components'

import FaqCategory from '../modules/cms/components/faqCategory/components'
import FaqManager from '../modules/cms/components/faqManager/components'

import EmailTemplate from '../modules/cms/components/emailTemplate/components'
import FormDownloadComponent from '../modules/formsAndDownload/components/formsDownload/component'

import HomepageSetting from '../modules/siteSettings/components/homepageSettings/components'

import {lazy} from 'react'

import ProductSchema from '../modules/onlineAccountOpening/productSchema'
import Documents from '../modules/onlineAccountOpening/documents'

export interface RouteModel {
  path?: any
  component?: React.ComponentType<RouteComponentProps>
  exact?: boolean
}

export const RouteList = [
  {
    path: '/dashboard',
    component: DashboardWrapper,
    exact: true,
  },
  {
    path: '/cms/content',
    component: ContentManager,
    exact: true,
  },

  {
    path: '/cms/menu-manager',
    component: MenuManager,
    exact: true,
  },
  {
    path: '/cms/banner',
    component: Banner,
    exact: true,
  },

  {
    path: '/popup/text-popup',
    component: TextPopup,
    exact: true,
  },

  {
    path: '/popup/road-block-popup',
    component: RoadBlockPopup,
    exact: true,
  },
  {
    path: '/cms/manage-faqs',
    component: FaqCategory,
    exact: true,
  },
  {
    path: '/cms/update-faqs/:id',
    component: FaqManager,
    exact: true,
  },
  {
    path: '/cms/email-template',
    component: EmailTemplate,
    exact: true,
  },

  {
    path: '/usermanagement/users',
    component: UserManagementIndex,
    exact: true,
  },
  {
    path: '/usermanagement/user-role',
    component: UserRoleManagementIndex,
    exact: true,
  },
  {
    path: '/usermanagement/role',
    component: RoleManagementIndex,
    exact: true,
  },
  {
    path: '/usermanagement/departments',
    component: Departments,
    exact: true,
  },
  {
    path: '/usermanagement/branch',
    component: Branches,
    exact: true,
  },
  {
    path: '/sitesetting/module',
    component: ModuleManager,
    exact: true,
  },
  {
    path: '/sitesetting/contact-setting',
    component: ContactSetting,
    exact: true,
  },
  {
    path: '/sitesetting/homepage-setting',
    component: HomepageSetting,
    exact: true,
  },
  {
    path: '/sitesetting/backend-setting',
    component: BackendSettings,
    exact: true,
  },
  {
    path: '/sitesetting/setting',
    component: Settings,
    exact: true,
  },
  {
    path: '/sitesetting/smtp-setting',
    component: SmtpSettings,
    exact: true,
  },
  {
    path: '/sitesetting/key-setting',
    component: KeySettings,
    exact: true,
  },

  // Products Schema
  {
    path: '/online-account-opening/documents',
    component: Documents,
    exact: true,
  },
  {
    path: '/online-account-opening/product-schema',
    component: ProductSchema,
    exact: true,
  },

  // BPM Form
  {
    path: '/form-generator',
    component: lazy(async () => await import('../modules/laravelForm/generator/index')),
    exact: true,
  },
  {
    path: '/form-manager',
    component: lazy(async () => await import('../modules/laravelForm/manager/index')),
    exact: true,
  },

  // New Cif Application
  {
    path: '/online-accounts/nagarik-accounts',
    component: lazy(
      async () => await import('../modules/newCifApplication/table/NagarikApplicationTable')
    ),
    exact: true,
  },
  {
    path: '/online-accounts/kiosk-accounts',
    component: lazy(
      async () => await import('../modules/newCifApplication/table/KioskApplicationTable')
    ),
    exact: true,
  },
  {
    path: '/online-accounts/nagarik-accounts/:module/:case_id',
    component: lazy(async () => await import('../modules/newCifApplication/onlineScreenPage')),
  },
  {
    path: '/online-accounts/kiosk-accounts/:module/:case_id',
    component: lazy(async () => await import('../modules/newCifApplication/onlineScreenPage')),
  },
  // RO Accounts
  {
    path: '/instant-accounts',
    component: lazy(async () => await import('../modules/roOnlineAccount')),
    exact: true,
  },
  {
    path: '/instant-accounts/:module/:case_id',
    component: lazy(async () => await import('../modules/roOnlineAccount/RoOnlineScreenPage')),
  },

  // Customer Online Account
  {
    path: '/customer-online-account',
    component: lazy(
      async () => await import('../modules/customerOnlineAccount/customerOnlineAccounts')
    ),
    exact: true,
  },
  {
    path: '/customer-online-account/customer-account/final-review/:case_id',
    component: lazy(
      async () =>
        await import(
          '../modules/customerOnlineAccount/customerOnlineAccounts/CustomerOnlineScreenPage'
        )
    ),
  },
  {
    path: '/preliminary-unverified',
    component: lazy(
      async () => await import('../modules/customerOnlineAccount/preliminary-unverified')
    ),
    exact: true,
  },

  // Quick Account Opening
  {
    path: '/quick-account-opening',
    component: lazy(async () => await import('../modules/quickAccountOpening')),
    exact: true,
  },
  {
    path: '/quick-account-opening/quick-account-opening-form',
    component: lazy(
      async () => await import('../modules/quickAccountOpening/quickAccountOpeningScreenPage')
    ),
    staticName: '',
    exact: true,
  },
  {
    path: '/quick-account-opening/quick-account-opening-form-completed/:case_id',
    component: lazy(async () => await import('../modules/quickAccountOpening/completedScreenPage')),
    staticName: '',
    exact: true,
  },
  {
    path: '/quick-account-opening/quick-account-opening-form/:case_id',
    component: lazy(
      async () => await import('../modules/quickAccountOpening/quickAccountOpeningScreenPage')
    ),
    staticName: '',
    exact: true,
  },

  // New Account Closure
  {
    path: '/account-closure',
    component: lazy(async () => await import('../modules/accountClosure')),
    exact: true,
  },
  {
    path: '/account-closure/account-closure-form',
    component: lazy(async () => await import('../modules/accountClosure/accountClosureScreenPage')),
    staticName: '',
    exact: true,
  },
  {
    path: '/account-closure/account-closure-form/:case_id',
    component: lazy(async () => await import('../modules/accountClosure/accountClosureScreenPage')),
    staticName: '',
    exact: true,
  },

  // New CIF New Account
  {
    path: '/new-cif-new-account',
    component: lazy(async () => await import('../modules/newCifNewAccount')),
    exact: true,
  },

  {
    path: '/new-cif-new-account/rejected-account-lists',
    component: lazy(
      async () => await import('../modules/newCifNewAccount/rejectedList/accountRejectedList')
    ),
    exact: true,
  },
  {
    path: '/new-cif-new-account/account-opening-requests',
    component: lazy(
      async () => await import('../modules/newCifNewAccount/branchMaker/accountOpeningRequestPage')
    ),
    exact: true,
  },
  {
    path: '/new-cif-new-account/create-new-account/normal-individual-preliminary-form',
    component: lazy(
      async () =>
        await import('../modules/newCifNewAccount/branchMaker/components/Individual/index')
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },

  {
    path: '/new-cif-new-account/create-new-account/normal-individual-preliminary-form/:case_id',
    component: lazy(
      async () =>
        await import(
          '../modules/newCifNewAccount/branchMaker/components/Individual/normalIndividualForm'
        )
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },
  {
    path: '/new-cif-new-account/create-new-account/normal-individual-preliminary-form/:case_id',
    component: lazy(
      async () =>
        await import(
          '../modules/newCifNewAccount/branchMaker/components/Individual/normalIndividualForm'
        )
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },
  {
    path: '/new-cif-new-account/create-new-account/final-form/:case_id',
    component: lazy(
      async () =>
        await import('../modules/newCifNewAccount/branchMaker/components/Individual/finalForm')
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },
  {
    path: '/account-opening-status',
    component: lazy(
      async () =>
        await import(
          '../modules/newCifNewAccount/branchMaker/components/account-status/AccountStatus'
        )
    ),
    staticName: 'Account Status',
    exact: true,
  },

  {
    path: '/account-opening-status/review-form/:case_id',
    component: lazy(async () => await import('../modules/completedForm/reviewForm')),
    staticName: 'New CIF New Accounts',
    exact: true,
  },


  {
    path: '/accounts/account-closure',
    component: lazy(
      async () =>
        await import(
          '../modules/newCifNewAccount/branchMaker/components/account-closure-report/AccountClosureReport'
        )
    ),
    staticName: 'Account Status',
    exact: true,
  },
  {
    path: '/accounts/ancillary-services',
    component: lazy(
      async () =>
        await import('../modules/newCifNewAccount/branchMaker/components/ancillaryServices/index')
    ),
    staticName: 'Ancillary Services',
    exact: true,
  },
  {
    path: '/new-cif-new-account/create-new-account/individualScreenForm/:case_id',
    component: lazy(
      async () =>
        await import('../modules/screening/individualJointMinorScreening/individualScreenPage')
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },
  {
    path: '/new-cif-new-account/create-new-account/individualScreenForm',
    component: lazy(
      async () =>
        await import('../modules/screening/individualJointMinorScreening/individualScreenPage')
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },

  {
    path: '/new-cif-new-account/create-new-account/corporateScreenForm',
    component: lazy(
      async () => await import('../modules/screening/corporateScreening/corporateScreenPage')
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },
  {
    path: '/new-cif-new-account/create-new-account/corporateScreenForm/:case_id',
    component: lazy(
      async () => await import('../modules/screening/corporateScreening/corporateScreenPage')
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },
  {
    path: '/new-cif-new-account/create-new-account/corporate-form',
    component: lazy(
      async () =>
        await import(
          '../modules/newCifNewAccount/branchMaker/components/corporate/normalCorporateForm'
        )
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },
  {
    path: '/new-cif-new-account/create-new-account/corporate-form/:case_id',
    component: lazy(
      async () =>
        await import(
          '../modules/newCifNewAccount/branchMaker/components/corporate/normalCorporateForm'
        )
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },
  {
    path: '/new-cif-new-account/create-new-account',
    component: lazy(
      async () => await import('../modules/newCifNewAccount/branchMaker/accountOpeningRequestPage')
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },

  {
    path: '/new-cif-new-account/branch-checker-review',
    component: lazy(
      async () => await import('../modules/newCifNewAccount/branchChecker/corporate/index')
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },

  {
    path: '/new-cif-new-account/branch-checker-review-individual',
    component: lazy(
      async () => await import('../modules/newCifNewAccount/branchChecker/Individual/index')
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },
  {
    path: '/new-cif-new-account/create-new-account/corporate-final-form/:case_id',
    component: lazy(
      async () =>
        await import('../modules/newCifNewAccount/branchMaker/components/corporate/finalForm')
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },

  // New CIF Only
  {
    path: '/new-cif-only',
    component: lazy(async () => await import('../modules/newCIFOnly/index')),
    exact: true,
  },
  {
    path: '/new-cif-only/opening-requests',
    component: lazy(
      async () => await import('../modules/newCIFOnly/branchMaker/OpeningRequestPage')
    ),
    exact: true,
  },
  {
    path: '/new-cif-only/opening-requests/individual-cif-form',
    component: lazy(
      async () => await import('../modules/newCIFOnly/branchMaker/Individual/NewCifOpenPage')
    ),
    exact: true,
  },
  {
    path: '/new-cif-only/opening-requests/corporate-cif-form',
    component: lazy(
      async () => await import('../modules/newCIFOnly/branchMaker/Corporate/CorporateCifScreenPage')
    ),
    exact: true,
  },
  {
    path: '/new-cif-only/opening-requests/individual-cif-form/:case_id',
    component: lazy(
      async () => await import('../modules/newCIFOnly/branchMaker/Individual/NewCifOpenPage')
    ),
    exact: true,
  },
  {
    path: '/new-cif-only/opening-requests/corporate-cif-form/:case_id',
    component: lazy(
      async () => await import('../modules/newCIFOnly/branchMaker/Corporate/CorporateCifScreenPage')
    ),
    exact: true,
  },

  // Existing CIF New Account
  {
    path: '/existing-cif-new-account',
    component: lazy(async () => await import('../modules/existingCIFNewAccount/index')),
    exact: true,
  },

  {
    path: '/existing-cif-new-account/rejected-account-lists',
    component: lazy(
      async () => await import('../modules/existingCIFNewAccount/rejectedList/accountRejectedList')
    ),
    staticName: 'Existing CIF New Accounts',
    exact: true,
  },
  {
    path: '/existing-cif-new-account/opening-requests',
    component: lazy(
      async () =>
        await import(
          '../modules/existingCIFNewAccount/branchMakerChecker/accountOpeningRequestPage'
        )
    ),
    staticName: 'Existing CIF New Accounts',
    exact: true,
  },

  {
    path: '/existing-cif-new-account/create-new-account/individualScreenForm',
    component: lazy(
      async () =>
        await import(
          '../modules/screening/individualJointMinorScreening/existingIndividualScreening'
        )
    ),
    staticName: 'Existing CIF New Accounts',
    exact: true,
  },

  {
    path: '/existing-cif-new-account/create-new-account/individualScreenForm/:case_id',
    component: lazy(
      async () =>
        await import(
          '../modules/screening/individualJointMinorScreening/existingIndividualScreening'
        )
    ),
    staticName: 'Existing CIF New Accounts',
    exact: true,
  },

  {
    path: '/existing-cif-new-account/create-new-account/corporateScreenForm',
    component: lazy(
      async () => await import('../modules/screening/corporateScreening/existingCorporateScreening')
    ),
    staticName: 'Existing CIF New Accounts',
    exact: true,
  },

  {
    path: '/existing-cif-new-account/create-new-account/corporateScreenForm/:case_id',
    component: lazy(
      async () => await import('../modules/screening/corporateScreening/existingCorporateScreening')
    ),
    staticName: 'Existing CIF New Accounts',
    exact: true,
  },

  {
    path: '/existing-cif-new-account/create-new-account/normal-individual-preliminary-form',
    component: lazy(
      async () =>
        await import(
          '../modules/existingCIFNewAccount/branchMakerChecker/Individual/normalIndividualForm'
        )
    ),
    staticName: 'Existing CIF New Accounts',
    exact: true,
  },
  {
    path: '/existing-cif-new-account/create-new-account/normal-individual-preliminary-form/:case_id',
    component: lazy(
      async () =>
        await import(
          '../modules/existingCIFNewAccount/branchMakerChecker/Individual/normalIndividualForm'
        )
    ),
    staticName: 'Existing CIF New Accounts',
    exact: true,
  },

  {
    path: '/existing-cif-new-account/create-new-account/corporate-form',
    component: lazy(
      async () =>
        await import(
          '../modules/existingCIFNewAccount/branchMakerChecker/corporate/normalCorporateForm'
        )
    ),
    staticName: 'Existing CIF New Accounts',
    exact: true,
  },
  {
    path: '/existing-cif-new-account/create-new-account/corporate-form/:case_id',
    component: lazy(
      async () =>
        await import(
          '../modules/existingCIFNewAccount/branchMakerChecker/corporate/normalCorporateForm'
        )
    ),
    staticName: 'Existing CIF New Accounts',
    exact: true,
  },

  {
    path: '/existing-cif-new-account/branch-checker-review-corporate',
    component: lazy(
      async () => await import('../modules/newCifNewAccount/branchChecker/corporate/index')
    ),
    staticName: 'Existing CIF New Accounts',
    exact: true,
  },

  {
    path: '/existing-cif-new-account/branch-checker-review-individual',
    component: lazy(
      async () => await import('../modules/newCifNewAccount/branchChecker/Individual/index')
    ),
    staticName: 'Existing CIF New Accounts',
    exact: true,
  },

  //ENquiry Module

  {
    path: '/cms/forms-and-download',
    component: FormDownloadComponent,
    exact: true,
  },

  // Find Account Module
  {
    path: '/find-account',
    component: lazy(async () => await import('../modules/findAccount')),
    staticName: 'Find Account',
    exact: true,
  },

  // Account Status Check Module
  {
    path: '/account-status-check',
    component: lazy(async () => await import('../modules/accountStatusCheck')),
    staticName: 'Account Status Check',
    exact: true,
  },
  // KYC UPDATE CASE
  {
    path: '/kyc-account-update',
    component: lazy(async () => await import('../modules/kycUpdate')),
    staticName: 'KYC Account Update',
    exact: true,
  },
  {
    path: '/kyc-account-update/form',
    component: lazy(async () => await import('../modules/kycUpdate/components/UpdateKycForm')),
    staticName: 'KYC Account Update',
    exact: true,
  },
  {
    path: '/kyc-account-update/form/:case_id',
    component: lazy(async () => await import('../modules/kycUpdate/components/UpdateKycForm')),
    staticName: 'KYC Account Update',
    exact: true,
  },

  {
    path: '/kyc-account-update/review-form/:case_id',
    component: lazy(async () => await import('../modules/kycUpdate/components/centralReview')),
    staticName: 'KYC Account Update',
    exact: true,
  },

  {
    path: '/kyc-account-update/completed-review/:case_id',
    component: lazy(async () => await import('../modules/kycUpdate/components/completedReview')),
    staticName: 'KYC Account Update',
    exact: true,
  },

  // OLD KYC UPDATE CASE
  {
    path: '/old-kyc-account-update',
    component: lazy(async () => await import('../modules/oldKycUpdate')),
    staticName: 'KYC Account Update',
    exact: true,
  },
  {
    path: '/old-kyc-account-update/form',
    component: lazy(async () => await import('../modules/oldKycUpdate/components/UpdateKycForm')),
    staticName: 'KYC Account Update',
    exact: true,
  },
  {
    path: '/old-kyc-account-update/form/:case_id',
    component: lazy(async () => await import('../modules/oldKycUpdate/components/UpdateKycForm')),
    staticName: 'KYC Account Update',
    exact: true,
  },

  {
    path: '/old-kyc-account-update/review-form/:case_id',
    component: lazy(
      async () => await import('../modules/oldKycUpdate/components/oldCentralReview')
    ),
    staticName: 'KYC Account Update',
    exact: true,
  },

  {
    path: '/old-kyc-account-update/completed-review/:case_id',
    component: lazy(
      async () => await import('../modules/oldKycUpdate/components/oldCompletedReview')
    ),
    staticName: 'KYC Account Update',
    exact: true,
  },

  //Product Scheme
  {
    path: '/master-data/product-scheme',
    component: lazy(async () => await import('../modules/productScheme/components')),
    staticName: 'Product Scheme',
    exact: true,
  },
  // Log Report
  {
    path: '/log-report',
    component: lazy(async () => await import('../modules/logViewer')),
    staticName: 'Log Report',
    exact: true,
  },

  // Capital Share — Maker
  {
    path: '/capital-share',
    component: lazy(async () => await import('../modules/capitalShare/list')),
    exact: true,
  },
  {
    path: '/capital-share/new',
    component: lazy(async () => await import('../modules/capitalShare/MakerForm')),
    exact: true,
  },
  {
    path: '/capital-share/edit/:case_id',
    component: lazy(async () => await import('../modules/capitalShare/MakerForm')),
    exact: true,
  },
  // Capital Share — Checker
  {
    path: '/capital-share/checker',
    component: lazy(async () => await import('../modules/capitalShare/CheckerQueue')),
    exact: true,
  },
  {
    path: '/capital-share/checker/:case_id',
    component: lazy(async () => await import('../modules/capitalShare/CheckerQueue/CheckerCaseView')),
    exact: true,
  },
  // Capital Share — Admin
  {
    path: '/capital-share/fee-config',
    component: lazy(async () => await import('../modules/capitalShare/FeeConfig')),
    exact: true,
  },

  // Kumari Remit IPO — Maker
  {
    path: '/kumari-remit-ipo',
    component: lazy(async () => await import('../modules/kumariRemitIpo/list')),
    exact: true,
  },
  {
    path: '/kumari-remit-ipo/new',
    component: lazy(async () => await import('../modules/kumariRemitIpo/MakerForm')),
    exact: true,
  },
  // Kumari Remit IPO — Checker
  {
    path: '/kumari-remit-ipo/checker',
    component: lazy(async () => await import('../modules/kumariRemitIpo/CheckerQueue')),
    exact: true,
  },
  {
    path: '/kumari-remit-ipo/checker/:case_id',
    component: lazy(async () => await import('../modules/kumariRemitIpo/CheckerQueue/CheckerCaseView')),
    exact: true,
  },
]
